<script setup lang="ts">
import SearchPartnerAndResult from '@/components/features/partners/SearchPartnerAndResult.vue'
</script>
<template>
  <div class="main h-full p-8">
    <search-partner-and-result></search-partner-and-result>
  </div>
</template>
